import {
  Children,
  Fragment,
  cloneElement,
  isValidElement,
  type ReactElement,
  type ReactNode,
} from 'react';
import {ChevronRight} from 'lucide-react';
import {cn} from '../lib/cn';
import type {BreadcrumbType} from './Breadcrumb';

export type BreadcrumbsProps = {
  className?: string;
  children: ReactNode;
};

export function Breadcrumbs({className, children}: BreadcrumbsProps) {
  const items = Children.toArray(children).filter(child => {
    if (!isValidElement(child)) {
      return true;
    }

    return !(child.props as BreadcrumbType).hidden;
  }) as ReactElement<BreadcrumbType>[];

  return (
    <nav className={cn('breadcrumbs', className)} aria-label="Breadcrumb">
      <ul className="m-0 flex list-none flex-wrap items-center gap-3 p-0">
        {items.map((child, index) => {
          const isLastVisibleItem = items.length - 1 === index;
          const childWithProps = isValidElement(child)
            ? cloneElement(child, {current: isLastVisibleItem})
            : child;

          return (
            <Fragment key={child.key ?? index}>
              {index > 0 ? (
                <ChevronRight
                  aria-hidden="true"
                  className="shrink-0 text-[var(--breadcrumbs-separator-color)]"
                  size={16}
                />
              ) : null}
              {childWithProps}
            </Fragment>
          );
        })}
      </ul>
    </nav>
  );
}
